/* Native mobile navigation, independent of legacy jQuery menu cloning. */
(function () {
  function init() {
    var menu = document.getElementById('AmmMobileMenu');
    if (!menu || menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    var opener, previousOverflow;
    var triggers = document.querySelectorAll('[data-amm-mobile-open]');
    function sync(open) { triggers.forEach(function (button) { button.setAttribute('aria-expanded', String(open)); }); }
    function close() { if (menu.open) menu.close(); }
    triggers.forEach(function (button) {
      button.addEventListener('click', function () {
        if (menu.open) return;
        opener = button;
        previousOverflow = document.body.style.overflow;
        menu.showModal();
        document.body.style.overflow = 'hidden';
        sync(true);
        menu.querySelector('[data-amm-mobile-close]').focus();
      });
    });
    menu.querySelector('[data-amm-mobile-close]').addEventListener('click', close);
    menu.addEventListener('click', function (event) { if (event.target === menu) { var r = menu.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
    menu.addEventListener('close', function () { document.body.style.overflow = previousOverflow || ''; sync(false); if (opener && opener.isConnected) opener.focus(); });
    menu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
